import { render, staticRenderFns } from "./RawChannel.vue?vue&type=template&id=ed6d79f6&scoped=true&"
import script from "./RawChannel.vue?vue&type=script&lang=js&"
export * from "./RawChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6d79f6",
  null
  
)

export default component.exports